import FlopyModflowBoundary from './FlopyModflowBoundary';

export default class FlopyModflowLineBoundary<T> extends FlopyModflowBoundary<T> {}
